import request from '@/utils/request'
import '@/utils/types.js'

export function passwordChange(data) {
  return request({
    url: `/api/account/password/change/`,
    method: 'post',
    data,
  })
}
